module.exports = __webpack_public_path__ + "img/leftcalf-ectomorph-female.af202cab.svg";